export class Phone {
  countryCode: string;
  number: string;
  constructor(countryCode: string, number: string) {
    this.countryCode = countryCode.replace(/[+ ]/, "");
    if (this.countryCode === "0") {
      this.countryCode = "";
    }
    if (this.countryCode) {
      this.number = number.replace(/(\+[1-9][0-9]{0,3} )/, "");
    } else {
      this.number = number;
    }
  }

  get phoneNumber() {
    if (this.number) {
      return (this.countryCode ? `+${this.countryCode} ` : "") + this.number;
    }
    return null;
  }
}
